<template>
<v-container style="max-width:1000px" class="mt-8">
  <h1>About this project and the people behind it</h1>
  <p>
      MetroSets is a collaboration between <a href='https://www.arizona.edu/'>University of Arizona</a> and <a href="tuwien.at/">TU Wien</a>.
  </p>
  <h3>Ben Jacobsen</h3>
  <p>
Ben Jacobsen is a BA student at the University of Arizona, studying mathematics and computer science. His interests include graph theory, computer security, and the intersection of computer science, mathematics, and philosophy.
  </p>
  <h3>Markus Wallinger</h3>
  <p>
<a href='https://www.ac.tuwien.ac.at/people/mwallinger/'>Markus Wallinger</a> is a PhD Student at TU Wien. He is interested in graph drawing, metro maps, information visualization, information design and computer generated art.
  </p>
  <h3>Stephen Kobourov</h3>
  <p>
<a href='https://www2.cs.arizona.edu/~kobourov/'>Stephen Kobourov</a> is a Professor of Computer Science at the University of Arizona. He works on graph drawing and information visualization, geometric algorithms and data structures, human computer interaction, and pervasive computing.
  </p>
  <h3>Martin Nöllenburg</h3>
  <p>
<a href='https://www.ac.tuwien.ac.at/people/noellenburg/'>Martin Nöllenburg</a> is a Professor at the Institute of Logic and Computation, TU Wien. His research interest is in graph drawing and network visualization, computational geometry, algorithm engineering and combinatorial optimization.
  </p>
  <h2>Citation</h2>
  <p>
  B. Jacobsen, M. Wallinger, S. Kobourov, and M. Nöllenburg. MetroSets: Visualizing sets as metro maps.  <br>
  IEEE Trans. Visualization and Computer Graphics, 2020, <a href="https://arxiv.org/abs/2008.09367">https://arxiv.org/abs/2008.09367</a>. To appear in InfoVis 2020.
  <p>
  <h2>Acknowledgements</h2>
  <p>
      We want to thank <b>Thomas van Dijk</b> for allowing us to use their code in our project. Their project <b>'Fast linear cartograms'</b> can be found on <a href='https://github.com/tcvdijk/fast-linear-carto'>Github</a>.
  </p>
  <p>
      We want to thank the creators of several libraries we extensively used in our project:
  </p>
  <p>
      Libraries used:<br>
      - <a href='https://www.djangoproject.com/'>Django</a><br>
      - <a href='https://www.django-rest-framework.org/'>Django Rest Framework</a><br>
      - <a href='https://networkx.github.io/'>NetworkX</a><br>
      - <a href='https://vuejs.org/'>Vue.js</a><br>
      - <a href='https://vuetifyjs.com/en/'>Vuetify</a><br>
      - <a href='https://d3js.org/'>D3</a><br>
      - <a href='https://www.papaparse.com'>PapaParse</a><br>
      - <a href='https://github.com/axios/axios'>Axios</a><br>
      - <a href='https://www.npmjs.com/package/save-svg-as-png'>save-svg-as-png</a><br>
      - <a href='https://numpy.org/'>Numpy</a><br>
      - <a href='http://numba.pydata.org/'>Numba</a><br>
      - <a href='https://developers.google.com/optimization'>OR-Tools</a><br>
      - <a href='https://graphviz.org/'>Graphviz</a><br>
      - <a href='https://ogdf.uos.de/'>Open Graph Drawing Framework</a><br>
  </p>
</v-container>
</template>

<script>
export default {
  name: 'About'
}
</script>
